import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import type { EmployeeFM } from './formModel';

export function validate(values: EmployeeFM) {
	const errors: ValidationErrors = {};

	if (!values.wageRate) {
		errors.wageRate = 'Wage Rate is required';
	}

	if (!values.accountId) {
		errors.accountId = 'User is required';
	}

	if (!isValidTextInput(values.fullName)) {
		errors.fullName = 'User is required';
	}

	if (!values.cdlStatus) {
		errors.cdlStatus = 'CDL status is required';
	}

	return errors;
}
